import { useState } from "react";
import { Button, Form, Container, Card, Row, Col } from "react-bootstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

function Register() {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [error, setError] = useState(null);
    const handleGoogleRegister = () => {
        console.log("Registrando con Google");
    };

    const handleFacebookRegister = () => {
        console.log("Registrando con Facebook");
    };
    const handleRegister = async () => {
        try {
            const response = await axios.post(`${API_URL}/register`, {
                fullName,
                email,
                password,
                phone,
                zipCode,
            });
            console.log("Usuario registrado:", response.data);
            alert("Registro exitoso");
        } catch (err) {
            setError(err.response?.data?.message || "Error en el registro");
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center local-hire-design" style={{ minHeight: '100vh' }}>
            <Card className="p-4 shadow-lg border-0 rounded-lg" style={{ maxWidth: '500px', width: '100%' }}>
                <Card.Body>
                    <h2 className="text-center mb-4 text-primary fw-bold">Crear una cuenta</h2>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Row className="mb-3">
                        <Col>
                            <Button
                                variant="outline-danger"
                                className="w-100 mb-2 rounded-pill shadow-sm"
                                onClick={handleGoogleRegister}
                            >
                                <i className="bi bi-google me-2"></i>
                                Registrarse con Google
                            </Button>

                            <Button
                                variant="outline-primary"
                                className="w-100 rounded-pill shadow-sm"
                                onClick={handleFacebookRegister}
                            >
                                <i className="bi bi-facebook me-2"></i>
                                Registrarse con Facebook
                            </Button>
                        </Col>
                    </Row>
                    <div className="text-center text-muted my-3">o completa este formulario</div>
                    <Form>
                        <Form.Group className="mb-3" controlId="formFullName">
                            <Form.Label>Nombre completo</Form.Label>
                            <Form.Control type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Correo electrónico</Form.Label>
                            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPassword">
                            <Form.Label>Contraseña</Form.Label>
                            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formZipCode">
                            <Form.Label>Código Postal</Form.Label>
                            <Form.Control type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
                        </Form.Group>
                        <Button variant="success" type="button" onClick={handleRegister} className="w-100">
                            Registrarse
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Register;
